<template>
  <v-container
    fluid
    fill-height
    class="d-flex justify-center justify-space-around align-center container"
  >
    <v-card
      dark
      color="transparent"
      class="text-center background-darkest-blur modal-border mb-1"
    >
      <div class="headline">Maintenance Mode</div>
      <v-card-text>
        <v-icon large class="mb-3">mdi-wrench</v-icon>
        <div class="mt-4">
          We are currently undergoing maintenance. Thank you for your patience.
        </div>
        <div v-if="msg">Ends at:</div>
        <div class="font-size-large time-text">{{ msg }}</div>
      </v-card-text>
      <v-card-actions>
        <v-btn plain color="primary" @click="reloadPage">Reload</v-btn>
        <v-btn plain color="primary" v-show="!msg" @click="goHome">Home</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      updateStart: "2024-08-15T15:08:00.009+00:00",
      updateDuration: 100,
      msg: "",
    };
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    getMaintenanceInfo() {
      this.$http.get("global-controller/updating-info").then((res) => {
        this.updateStart = res.body.updateStart;
        this.updateDuration = res.body.updateDuration;
        if (!res.body.updating) {
          this.goHome();
          return;
        }
        const maintenanceStartTime = new Date(this.updateStart); // Replace with actual start time in GMT
        const maintenanceEndTime = new Date(
          maintenanceStartTime.getTime() + this.updateDuration * 60000
        );
        const now = new Date();
        const remainingTimeMs = maintenanceEndTime - now;
        if (remainingTimeMs > 0) {
          // Convert remaining time to hours, minutes, seconds
          // const hours = Math.floor(remainingTimeMs / (1000 * 60 * 60));
          // const minutes = Math.floor((remainingTimeMs % (1000 * 60 * 60)) / (1000 * 60));
          // const seconds = Math.floor((remainingTimeMs % (1000 * 60)) / 1000);

          this.msg = `${maintenanceEndTime.toLocaleString()}`;
        } else {
          // this.msg = "Maintenance is complete.";
          this.msg = "";
        }
      });
    },
    goHome() {
      this.$router.push("/home");
    },
  },
  mounted() {
    this.getMaintenanceInfo();
  },
};
</script>

<style scoped>
.v-card {
  max-width: 400px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container {
  background-color: var(--v-darkest);
  justify-content: space-around;
}
.text-center {
  text-align: center;
}
.time-text {
  margin-top: 8px;
  color: #9efff0;
  font-weight: 600;
}
</style>
